<template>
    <button
        v-tippy="t('editorUndo')"
        :class="[buttonState(editor.can().undo()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().undo()"
        @click="editor.chain().focus().undo().run()"
    >
        <MdiUndo class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import { MdiUndo } from 'materialdesignicons-vue3/icons/';

    defineExpose({
        name: 'UndoButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
